import { blockCategories } from '../../categories';

export default function (editor, pagesList, data, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    opts = {
        category: blockCategories.navigation,
        label: 'Breadcrumb',
        block: {},
        props: {},
        style: {},
        stylePrefix: 'breadcrumb-',
        ...opts,
    };

    const { Components, Blocks } = editor;

    domComponents.addType('breadcrumb-item', {
        model: {
            defaults: {
                tagName: 'li',
                draggable: ['breadcrumb-container'],
                droppable: false,
                attributes: { class: 'cms-breadcrumbs__li' },
                traits: [
                    {
                        type: 'text',
                        name: 'label',
                        label: 'Label',
                        changeProp: 1,
                    },
                    {
                        type: 'text',
                        name: 'link',
                        label: 'Link (URL)',
                        changeProp: 1,
                    },
                    {
                        type: 'checkbox',
                        name: 'active',
                        label: 'Active (Current Page)',
                        changeProp: 1,
                    },
                ],
                label: 'Breadcrumb Item',
                icon: '<i class="fa fa-link"></i>',
                content: '<div class="cms-breadcrumbs-li__container"></div>',
            },

            init() {
                this.on('change:label', this.updateContent);
                this.on('change:link', this.updateContent);
                this.on('change:active', this.updateContent);
                this.updateContent();
            },

            updateContent() {
                const label = this.get('label') || 'Home';
                const link = this.get('link') || '/';
                const isActive = this.get('active');
                const linkClass = 'cms-breadcrumbs__item';
                const labelMarkup = `<div class="cms-breadcrumbs__label">${label}</div>`;
                const linkMarkup = isActive
                    ? `<span class="${linkClass}">${labelMarkup}</span>`
                    : `<a href="${link}" class="${linkClass}">${labelMarkup}</a>`;

                this.set(
                    'content',
                    `<div class="cms-breadcrumbs-li__container">${linkMarkup}</div>`
                );
            },
        },
    });

    //breadcrumb container component
    domComponents.addType('breadcrumb-container', {
        model: {
            defaults: {
                tagName: 'nav',
                draggable: true,
                droppable: ['breadcrumb-item'],
                attributes: {
                    class: 'cms-breadcrumbs',
                    'aria-label': 'Breadcrumb',
                },
                traits: [
                    {
                        type: 'select',
                        name: 'separator',
                        label: 'Separator',
                        options: [
                            { value: '/', name: 'Slash (/)' },
                            { value: '>', name: 'Greater than (>)' },
                            { value: '→', name: 'Arrow (→)' },
                            { value: '•', name: 'Bullet (•)' },
                            { value: '|', name: 'Pipe (|)' },
                        ],
                        changeProp: 1,
                    },
                ],
                components: [],
                label: 'Breadcrumb Navigation',
                icon: '<i class="fa fa-list"></i>',
                content: '<ol class="cms-breadcrumbs__ol"></ol>',
            },

            init() {
                if (!this.components().length) {
                    const itemsList = [];
                    const homepageItem = pagesList.items.find(
                        (item) => item.url === 'homepage'
                    );

                    if (homepageItem) {
                        itemsList.push({
                            url: '/',
                            title: homepageItem.title,
                        });
                    }

                    if (data.url) {
                        const urlParts = data?.url?.split('/')?.filter(Boolean);
                        if (urlParts.length > 0) {
                            urlParts.forEach((part) => {
                                const matchedItem = pagesList.items.find(
                                    (item) =>
                                        item?.url?.split('/')[
                                        item?.url?.split('/').length - 1
                                        ] === part
                                );

                                if (matchedItem) {
                                    itemsList.push({
                                        url: matchedItem.url,
                                        title: matchedItem.title,
                                    });
                                }
                            });
                        }
                    }
                    itemsList.forEach((item, index) => {
                        this.append({
                            type: 'breadcrumb-item',
                            label: item.title,
                            link: item.url,
                            active: index === itemsList.length - 1,
                        });
                    });
                }
                this.on('change:separator', this.updateSeparator);
                this.updateSeparator();
            },

            updateSeparator() {
                const separator = this.get('separator') || '>';
                this.addStyle({ '--separator': `"${separator}"` });
            },
        },

        view: {
            init() {
                this.listenTo(
                    this.model,
                    'change:components',
                    this.renderBreadcrumbs
                );
                this.listenTo(
                    this.model,
                    'change:separator',
                    this.renderBreadcrumbs
                );
                this.renderBreadcrumbs();
            },

            renderBreadcrumbs() {
                const components = this.model.get('components');
                const list = this.el.querySelector('.cms-breadcrumbs__ol');
                if (list && components) {
                    list.innerHTML = '';
                    components.forEach((comp, index) => {
                        const label = comp.get('label') || 'Item';
                        const link = comp.get('link') || '/';
                        const isActive = comp.get('active');
                        const linkClass = 'cms-breadcrumbs__item';
                        const labelMarkup = `<div class="cms-breadcrumbs__label">${label}</div>`;
                        const linkMarkup = isActive
                            ? `<span class="${linkClass}">${labelMarkup}</span>`
                            : `<a href="${link}" class="${linkClass}">${labelMarkup}</a>`;
                        const li = document.createElement('li');
                        li.className = 'cms-breadcrumbs__li';
                        li.innerHTML = `<div class="cms-breadcrumbs-li__container">${linkMarkup}</div>`;
                        list.appendChild(li);
                    });
                }
            },
        },
    });

    // breadcrumb block
    blockManager.add('breadcrumb-block', {
        label: 'Brotkrumen',
        category: blockCategories.basic,
        media:
            '<svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/><path d="M6 6L4.59 7.41 9.17 12l-4.58 4.59L6 18l6-6z"/></svg>',
        content: {
            type: 'breadcrumb-container',
        },
        ...opts.block,
    });

    //managing breadcrumb items
    editor.Commands.add('breadcrumb:add-item', {
        run(editor, sender, options) {
            const selected = editor.getSelected();
            if (selected && selected.get('type') === 'breadcrumb-container') {
                const newItem = {
                    type: 'breadcrumb-item',
                    label: 'New Item',
                    link: '#',
                    active: false,
                };
                selected.append(newItem);
            }
        },
    });

    editor.Commands.add('breadcrumb:remove-item', {
        run(editor, sender, options) {
            const selected = editor.getSelected();
            if (selected && selected.get('type') === 'breadcrumb-item') {
                selected.remove();
            }
        },
    });

    // context menu options
    editor.on('component:selected', (component) => {
        const toolbar = component.get('toolbar') || [];
        if (component.get('type') === 'breadcrumb-container') {
            const hasAddButton = toolbar.some(
                (btn) => btn.command === 'breadcrumb:add-item'
            );

            if (!hasAddButton) {
                component.set('toolbar', [
                    ...toolbar,
                    {
                        attributes: { class: 'fa fa-plus toolbar-icon' },
                        command: 'breadcrumb:add-item',
                        label: '',
                    },
                ]);
            }
        }
    });
}
